import { Components, Theme } from '@mui/joy';

export const JoyModalConfig: Partial<Components<Theme>> = {
  JoyModal: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 500,
          '.MuiModal-backdrop': {
            'backdrop-filter': 'none',
            backgroundColor: theme.palette.common.black,
            opacity: '0.5',
          },
        };
      },
    },
  },
  JoyModalDialog: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          top: 'unset',
          left: 'unset',
          transform: 'unset',
          width: 'min-content',
          backgroundColor: theme.palette.common.white,
          fontSize: '16px',
          gap: '16px',
          paddingInline: '16px',
          '--ModalDialog-minWidth': '600px',
          '--Icon-color': 'currentcolor',
        };
      },
    },
    defaultProps: {},
  },
  JoyModalClose: {
    styleOverrides: {
      root: {
        position: 'static',
        top: 'unset',
        right: 'unset',
      },
    },
  },
};
